import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Loading from "../../components/Loading";
import { getEventsRequest, getParticipantsRequest } from "../../actions";
import {
  EVENT_INPUT_DEFAULT_OPTION,
  EVENTS_NOT_FOUND,
  PARTICIPANT_RESGISTERED_FAILED,
} from "../../types";
import "../../assets/styles/events/RegisterAssistance.css";
import { requests } from "../../axios";
import { useFormik } from "formik";
import ScafTable from "../../components/ScafTable";

const RegisterAssistance = (props) => {
  const headers = ["Id", "Nombre", "Hora"];

  const [requestState, setRequestState] = useState({
    loading: true,
    error: null,
  });

  const [participantState, setParticipantState] = useState({
    data: null,
  });

  const [assistanceState, setAssistanceState] = useState({
    data: null,
  });

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    try {
      if (!props.events.length) {
        const response = await requests.events.getAllEvents();
        props.getEventsRequest(response.data);
      }
      setRequestState({ ...requestState, loading: false });
    } catch (error) {
      console.log(error.response.status);
      setRequestState({
        loading: false,
        error: EVENTS_NOT_FOUND,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      eventId: "",
      participantId: "",
    },
    onSubmit: async (values) => {
      try {
        setRequestState({
          ...requestState,
          error: null,
        });
        const response = await requests.participants.registerAssistance(
          values.eventId,
          values.participantId.toUpperCase()
        );
        handleParticipants();
        setParticipantState({ data: response.data.name });
        values.participantId = "";
      } catch (error) {
        console.log(error);
        setRequestState({
          loading: false,
          error: PARTICIPANT_RESGISTERED_FAILED,
        });
      }
    },
  });

  const options =
    props.events.length &&
    props.events.map((event, index) => {
      return (
        <option value={event.eventId} key={index}>
          {event.name}
        </option>
      );
    });

  const handleParticipants = async () => {
    const eventId = document.getElementById("event").value;
    formik.setFieldValue("eventId", eventId);
    const response =
      eventId && (await requests.events.getAllParticipants(eventId));
    props.getParticipantsRequest(response.data);
    setAssistance(response.data);
  };

  const setAssistance = (participants) => {
    const assistance = participants
      .filter((participant) => participant.attended)
      .sort((a, b) => {
        if (a.checkInTime < b.checkInTime) return 1;
        if (a.checkInTime > b.checkInTime) return -1;
        return 0;
      })
      .map((participant) => {
        const formatted = participant.checkInTime
          .split(":")
          .slice(0, 2)
          .join(":");
        return {
          Id: participant.participantId,
          Nombre: participant.name,
          Hora: formatted,
        };
      });
    setAssistanceState({ data: assistance });
  };

  return (
    <>
      {requestState.loading ? (
        <Loading />
      ) : (
        <>
          <section className="userform" role="form">
            <form
              className="square-form register-event-grid"
              onSubmit={formik.handleSubmit}
            >
              <div className="event-input-container">
                <h5 className="event-label">Evento</h5>
                <select
                  className="userform-select event-form-select"
                  id="event"
                  name="event"
                  data-testid="eventInput"
                  value={formik.values.eventId}
                  onChange={handleParticipants}
                  required
                >
                  <option value="">{EVENT_INPUT_DEFAULT_OPTION}</option>
                  {options}
                </select>
              </div>
              <div className="participant-input-container">
                <h5 className="participant-label">Participante</h5>
                <input
                  className="userform-input-text participant-input"
                  id="participant"
                  name="participant"
                  data-testid="participantInput"
                  {...formik.getFieldProps("participantId")}
                  required
                ></input>
              </div>
              {requestState.error && (
                <h6 className="bad-request error-message" role="alert">
                  {requestState.error}
                </h6>
              )}
            </form>
          </section>
          <section>
            <h3 className="participant-name-label">{participantState.data}</h3>
          </section>
          <ScafTable headers={headers} rows={assistanceState.data || []} />
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    events: state.events,
    participants: state.participants,
  };
};

const mapDispatchToProps = {
  getEventsRequest,
  getParticipantsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterAssistance);
